import { AspectRatio, Box, Flex, Heading, Link } from "@chakra-ui/react";
import React from "react";
import { IconType } from "react-icons";

interface ApplicationTileProps {
  title: string;
  icon: IconType;
  gradientFrom: string;
  gradientTo: string;
  externalUrl?: string;
}

const ApplicationTile: React.FC<ApplicationTileProps> = ({
  title,
  icon,
  gradientFrom,
  gradientTo,
  externalUrl,
}) => {
  const Icon = icon as React.ElementType;
  return (
    <Link href={externalUrl} isExternal _hover={{ textDecoration: "none" }}>
      <AspectRatio boxSize="100%" minW={40} maxW={40} ratio={1}>
        <Box
          borderRadius={16}
          overflow="hidden"
          position="relative"
          zIndex={0}
          sx={{
            background: `linear-gradient(253.58deg, ${gradientFrom} 1.55%, ${gradientTo} 66.84%)`,
            "&::after": {
              content: '""',
              display: "block",
              height: "100%",
              width: "100%",
              position: "absolute",
              top: 0,
              left: 0,
              opacity: 0,
              zIndex: -1,
              transition: "opacity 0.5s",
              background: `linear-gradient(253.58deg, ${gradientTo} 1.55%, ${gradientFrom} 66.84%)`,
              borderRadius: "16px",
            },
            "&:hover::after": {
              opacity: 1,
            },
          }}
        >
          <Box position="absolute" top={4} left={4}>
            <Flex
              boxSize={14}
              borderRadius="full"
              bg="white"
              alignItems="center"
              justifyContent="center"
            >
              <Icon size={24} color={gradientTo} />
            </Flex>
          </Box>
          <Heading
            size="sm"
            position="absolute"
            bottom={4}
            left={4}
            right={4}
            noOfLines={2}
            color="white"
          >
            {title}
          </Heading>
        </Box>
      </AspectRatio>
    </Link>
  );
};

export default ApplicationTile;
